









































import { mdiChevronLeft } from '@mdi/js';
import { Component, Prop, Vue } from 'vue-property-decorator';

import { BreadCrumbsModule } from '@/store/modules/breadCrumbs';

@Component
export default class BreadCrumbs extends Vue {
  @Prop() private diver!: string;
  mdiChevronLeft = mdiChevronLeft;

  get breadCrumbsList() {
    return BreadCrumbsModule.breadCrumbs || this.$route.meta.breadCrumbs;
  }

  goBack() {
    if (BreadCrumbsModule.backLocation) {
      this.$router.replace(BreadCrumbsModule.backLocation);
      return;
    }

    this.$router.go(-1);
  }
}
